//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import lan from "./components/lan/index";
import wan from "./components/wan/index";
import mgt from "./components/mgt/index";
export default {
  props: ["deviceDid", "deviceSn", "deviceSoftwareVer"],
  components: {
    lan: lan,
    wan: wan,
    mgt: mgt
  },
  data: function data() {
    return {
      active: 'lan'
    };
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler: function handler(newValue, oldValue) {
        this.active = 'lan';
      }
    }
  }
};